import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { isPendingAction, isRejectedAction, isFullfieldAction } from './slice.helper';
import Api from '../../services/catalogue-diamant.service';



export const listCatalogueDiamant = createAsyncThunk(
    "CatalogueDiamant/adm-list",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const filterCatalogueDiamant = createAsyncThunk(
    "CatalogueDiamant/adm-filter",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.filterAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const viewCatalogueDiamant = createAsyncThunk(
    "CatalogueDiamant/adm-view",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.view(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createCatalogueDiamant = createAsyncThunk(
    "CatalogueDiamant/adm-create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.create(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateCatalogueDiamant = createAsyncThunk(
    "CatalogueDiamant/adm-update",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.update(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const deleteCatalogueDiamant = createAsyncThunk(
    "CatalogueDiamant/adm-delete",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.remove(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const uploadAfficheCatalogueDiamant = createAsyncThunk(
    "CatalogueDiamant/adm-uploadAffiche",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.uploadAffiche(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const getPublicListCatalogueDiamant = createAsyncThunk(
    "CatalogueDiamant/adm-getPublicList",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.getPublicList(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)



export const createCDM = createAsyncThunk(
    "Catalogue/adm-createCDM",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.createCDM(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateCDM = createAsyncThunk(
    "Catalogue/adm-updateCDM",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateCDM(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const deleteCDM = createAsyncThunk(
    "Catalogue/adm-removeCDM",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.removeCDM(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)



export const updateStockTampon = createAsyncThunk(
    "Catalogue/adm-updateStockTampon",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateStockTampon(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const listStockTamponConfig = createAsyncThunk(
    "Catalogue/adm-listStockTamponConfig",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listStockTamponConfig(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const listStockTamponAlert = createAsyncThunk(
    "Catalogue/adm-listStockTamponAlert",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listStockTamponAlert(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)






const initialState = {
    loading: false,
    error: '',
    sel_CatalogueDiamant: null
}

const CatalogueDiamantSlice = createSlice({
    name: "CatalogueDiamant",
    initialState: initialState,
    reducers: {
        clear: (state) => {
            Object.assign(state, initialState)
        },

    },
    extraReducers: builder => {
        builder
            .addMatcher(isFullfieldAction, (state, action) => {
                state[action.meta.requestId] = 'fulfilled'
                state.loading = false;
                state.error = '';
            })
            .addMatcher(isPendingAction, (state, action) => {
                state[action.meta.requestId] = 'pending'
                state.loading = true;
                state.error = '';
            })
            .addMatcher(isRejectedAction, (state, action) => {
                state[action.meta.requestId] = 'rejected'
                state.loading = false;
                state.error = action.payload;
            })



    }
})

const { reducer } = CatalogueDiamantSlice;
export const { clear } = CatalogueDiamantSlice.actions;
export default reducer;